import { useEffect, useState } from "react";
import { apiRequest } from "../services/apiClient";
const EMPTY = { clientId: "", clientSecret: "", baseUrl: "https://liveapi.sinalite.com", audience: "https://apiconnect.sinalite.com" };

export default function AdminSupplierSettings() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [testing, setTesting] = useState(false);
  const [testResult, setTestResult] = useState(null);

  useEffect(() => {
    async function load() {
      try {
        const data = await apiRequest("/admin/settings/supplierSettings");
        setForm(prev => ({ ...prev, ...data }));
      } catch (error) {
        setMessage(error.message);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  function update(key, value) {
    setForm(prev => ({ ...prev, [key]: value }));
  }

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    setMessage("");
    try {
      const data = await apiRequest("/admin/settings/supplierSettings", { method: "PUT", body: JSON.stringify(form) });
      setForm(prev => ({ ...prev, ...data }));
      setMessage("Supplier API settings saved.");
    } catch (error) {
      setMessage(error.message);
    } finally {
      setSaving(false);
    }
  }

  async function testConnection() {
    setTesting(true);
    setTestResult(null);
    try {
      const data = await apiRequest("/admin/supplier-settings/test", { method: "POST", body: JSON.stringify(form) });
      setTestResult({ ok: true, message: data.message });
    } catch (error) {
      setTestResult({ ok: false, message: error.message });
    } finally {
      setTesting(false);
    }
  }

  if (loading) return <div style={{ padding: 60, color: "rgba(255,255,255,0.5)" }}>Loading supplier settings...</div>;

  return (
    <div style={{ maxWidth: 720 }}>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ color: "#fff", margin: 0 }}>Supplier API Settings</h2>
        <p style={{ color: "rgba(255,255,255,0.45)", fontSize: 13 }}>
          Configure the supplier connection used when an admin approves an order. Credentials are never sent to customers or the browser.
        </p>
      </div>
      <form className="adm-card" onSubmit={save}>
        <div className="adm-card-header"><span className="adm-card-title">SinaLite connection</span></div>
        <div style={{ padding: 22, display: "grid", gap: 14 }}>
          <Field label="Client ID" value={form.clientId} onChange={v => update("clientId", v)} placeholder="SinaLite client ID" />
          <Field label="Client secret" type="password" value={form.clientSecret} onChange={v => update("clientSecret", v)} placeholder="Leave ******** unchanged to keep it" />
          <Field label="API base URL" value={form.baseUrl} onChange={v => update("baseUrl", v)} placeholder="https://liveapi.sinalite.com" />
          <Field label="OAuth audience" value={form.audience} onChange={v => update("audience", v)} placeholder="https://apiconnect.sinalite.com" />
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <button className="adm-btn adm-btn-primary" disabled={saving}>{saving ? "Saving..." : "Save supplier settings"}</button>
            <button type="button" className="adm-btn" disabled={testing} onClick={testConnection}>{testing ? "Testing..." : "Test connection"}</button>
            {message && <span style={{ color: message === "Supplier API settings saved." ? "#4ade80" : "#f87171", fontSize: 13 }}>{message}</span>}
          </div>
          {testResult && <span style={{ color: testResult.ok ? "#4ade80" : "#f87171", fontSize: 13 }}>{testResult.message}</span>}
        </div>
      </form>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", placeholder }) {
  return <label style={labelStyle}><span>{label}</span><input type={type} value={value ?? ""} onChange={e => onChange(e.target.value)} placeholder={placeholder} required style={inputStyle} /></label>;
}

const labelStyle = { display: "flex", flexDirection: "column", gap: 7, color: "rgba(255,255,255,0.65)", fontSize: 12, fontWeight: 600 };
const inputStyle = { background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.14)", borderRadius: 6, padding: "10px 12px", color: "#fff", fontFamily: "inherit", fontSize: 14 };